import axios from 'axios';

// Get API endpoint from environment variable, with fallback to localhost for development.
// When REACT_APP_USE_BETA_API is set, use a relative URL so setupProxy can forward to the beta API.
export const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.videoplussensors.com/api'
    : process.env.REACT_APP_USE_BETA_API === 'true'
      ? '/api'
      : 'http://localhost:8081/api');

export const axiosInstance = axios.create({
  baseURL: API_ENDPOINT,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve();
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401 || originalRequest._retry || originalRequest.url === '/auth/refresh') {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(() => axiosInstance(originalRequest));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      await axiosInstance.post('/auth/refresh');
      processQueue(null);
      return axiosInstance(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError);
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export const convertStringJsonToObject = (stringJson) => JSON.parse(stringJson.toString());
